/*
 * Enable Bootstrap Tooltips
 * https://getbootstrap.com/docs/5.2/components/tooltips/#enable-tooltips
 */

(function (c2, $) {
  'use strict';
  function init(selector) {
    var $container = selector ? $(selector) : $(document);
    setTitlesFromSourceElements($container);

    if (selector) {
      $(selector).find('[data-bs-toggle="tooltip"]').tooltip();
    } else {
      $('[data-bs-toggle="tooltip"]').tooltip();
    }
  }
  /*
   * Our way of letting the tooltip message be defined by some other element on the page.
   */
  function setTitlesFromSourceElements($container) {
    var $trigger, $source;

    $container.find('[data-bs-toggle="tooltip"][data-tooltip-source]').each(function() {
      $trigger = $(this);
      $source = $($trigger.data('tooltip-source'));
      $trigger.attr('title', $source.html());
    });
  }

  /*
   * Callers that re-render markup under `selector` (e.g. Vue's v-html/v-if) must
   * call this to remove the old tooltips before the old nodes are removed.
   */
  function dispose(selector) {
    var $container = selector ? $(selector) : $(document);
    $container.find('[data-bs-toggle="tooltip"]').each(function() {
      var instance = bootstrap.Tooltip.getInstance(this);
      if (instance) {
        instance.dispose();
      }
    });
  }

  c2.tooltips = {
    init: init,
    dispose: dispose
  };
})(window.c2, window.jQuery);
